import { warn } from "@swivl-mono/helpers";
import { InheritanceStatus, NLPBrainActionType, NLPBrainInterface, isNLPBrain } from "@swivl-mono/types";
import { SelectableOption } from "@swivl-mono/ui";
import _ from "lodash";
import * as React from "react";

import { PageLoadingView } from "../../App/Layout/Loading/LoadingView";
import { BrainsModel } from "../../Models/Brains/Brains.Model";
import NLPModel from "../../Models/NLP/NLP.Model";
import { QuestsModel } from "../../Models/Quests/Quests.Model";
import "./BrainsView.scss";
import { BrainsViewIntent } from "./Intent/BrainsViewIntent";

interface Props {
  brain: NLPBrainInterface;
}
export default function NLPBrainsView(props: Props) {
  const { brains } = BrainsModel.useState((state) => state);

  const { brain } = props;
  const { cachesMap } = NLPModel.useState((state) => state);

  React.useEffect(() => {
    NLPModel.loadCaches(false);
    QuestsModel.loadQuestsList(false);
    BrainsModel.load(false);
  }, []);

  // React.useEffect(() => {
  //   if (!brain) return;
  //   NavBar.set(
  //     <NavBar.Component.Back />,
  //     <NavBar.Component.Title title={brain.name} />,
  //     null,
  //     brain.name
  //     );
  // }, [brain])

  const nlpCache = brain && cachesMap && isNLPBrain(brain) ? cachesMap[brain.model.appId] : null;

  if (!brain || !nlpCache) {
    warn("No brain or cache", brain, nlpCache);
    return <PageLoadingView navBarTitle=" " pageTitle=" " />;
  }
  if (!isNLPBrain(brain)) {
    return <div>Not an NLP Brain</div>;
  }
  nlpCache.intents.forEach((intent) => {
    if (!brain.data.actions[intent.name]) {
      brain.data.actions[intent.name] = {
        type: NLPBrainActionType.QUEST,
        intent: intent.name,
        active: false,
        goto: ""
      };
    }
  });
  const actionsArray = Object.values(brain.data.actions).sort((a: any, b: any) => {
    if (a.intent < b.intent) {
      return -1;
    }
    if (a.intent > b.intent) {
      return 1;
    }
    return 0;
  });

  const isParent = brain.inheritance === InheritanceStatus.IS_PARENT;

  const brainItems: SelectableOption[] = [
    {
      label: "Brains",
      isHeading: true
    }
  ];
  brains?.forEach((brainToAdd) => {
    if (brainToAdd.slug === brain.slug) {
      return;
    }
    brainItems.push({ label: brainToAdd.name, value: "brain_" + brainToAdd.slug, data: { isBrain: true } });
  });

  return (
    <div className="BrainsView NLPBrainsView">
      <label>Default Unhandled</label>
      <BrainsViewIntent brain={brain} action={brain.data.unhandled} isParent={isParent} isDefault={true} brainItems={brainItems} />
      <hr />
      <label>Intents</label>
      {actionsArray.map((action) => {
        return <BrainsViewIntent brain={brain} action={action} isParent={isParent} brainItems={brainItems} />;
      })}
    </div>
  );
}
